import React from "react";
import PricingSection from "../../components/pricingSection";

function Pricing() {
  return <PricingSection />;
}

export default Pricing;
